import { type ActionItem } from 'shared/ui'
import { type RowInvite } from 'entities/Users/model/Table/RowInvite'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { type IResponseCancelInvite, type IResponseResendInvite } from 'entities/Users/api/types'
import { cancelInvite } from 'pages/settings/pages/members/ui/actions/cancelInvite/cancelInvite'
import { resendInvite } from './resendInvites/resendInvite'
import { copyInviteLink } from './copyInviteLink/copyInviteLink'

type IndividualActionParams = {
  onCancelInvites: (response: IResponseCancelInvite) => void
  onResendInvite: (response: IResponseResendInvite, count: number) => void
}

export const getPendingMembersActions = (
  entities: IEntitiesStore,
  invite: RowInvite,
  params: IndividualActionParams
): ActionItem[] => {
  const { onCancelInvites, onResendInvite } = params

  return [
    copyInviteLink(invite),
    resendInvite([invite], (response) => onResendInvite(response, 1)),
    cancelInvite(entities, [invite], onCancelInvites),
  ]
}
